import { GET_TIPO_GASTOS_CIERRE } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {


    switch (action.type) {

        case GET_TIPO_GASTOS_CIERRE + "_SUCCESS":

            return action.payload.data;

        default:
            return state;
    }
}